import { render, staticRenderFns } from "./publish-product-select-game.vue?vue&type=template&id=47603b98&scoped=true&"
import script from "./publish-product-select-game.vue?vue&type=script&lang=js&"
export * from "./publish-product-select-game.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-select-game.vue?vue&type=style&index=0&id=47603b98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47603b98",
  null
  
)

export default component.exports